import { render, staticRenderFns } from "./ConfirmShipment.vue?vue&type=template&id=72f67f54&scoped=true&"
import script from "./ConfirmShipment.vue?vue&type=script&lang=ts&"
export * from "./ConfirmShipment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f67f54",
  null
  
)

export default component.exports